<div class="game-blog">
  <header class="game-blog__header">
    <h2 class="game-blog__title">Blog de {{ gameName() }}</h2>
    <p class="game-blog__subtitle">Guías, análisis y noticias sobre {{ gameName() }}.</p>
  </header>

  <div class="game-blog__carousel-wrapper">
    <button
      class="game-blog__arrow game-blog__arrow--prev"
      type="button"
      aria-label="Anterior"
      (click)="scrollPrev()"
    >
      <app-icon [icon]="chevronLeft" [size]="20" />
    </button>

    <div class="game-blog__track" #track>
      @for (post of posts(); track post.id) {
        <article class="game-blog__slot">
        <a [routerLink]="['/blog', post.slug]" class="blog-card__image-link" tabindex="-1" aria-hidden="true">
          <img
            [ngSrc]="post.imageUrl"
            [alt]="post.imageAlt || post.title"
            [width]="post.imageWidth"
            [height]="post.imageHeight"
            class="blog-card__image"
          />
        </a>

        <div class="blog-card__content">
          <div class="blog-card__meta">
            <time class="blog-card__date">{{ post.publishedAt | blogDate }}</time>
            <span class="blog-card__category">{{ post.game.name }}</span>
          </div>

          <h3 class="blog-card__title">
            <a [routerLink]="['/blog', post.slug]" class="blog-card__title-link">{{ post.title }}</a>
          </h3>

          <p class="blog-card__excerpt">{{ post.excerpt }}</p>

          <!-- B125: la tarjeta pública no trae autor (P41); solo si llega. -->
          @if (post.authorName) {
            <div class="blog-card__author">
              <img
                class="blog-card__avatar"
                [src]="post.authorAvatarUrl"
                [alt]="post.authorName"
                width="40"
                height="40"
                loading="lazy"
              />
              <div class="blog-card__author-info">
                <span class="blog-card__author-name">{{ post.authorName }}</span>
                <span class="blog-card__author-role">{{ post.authorRole }}</span>
              </div>
            </div>
          }
        </div>
        </article>
      }
    </div>

    <button
      class="game-blog__arrow game-blog__arrow--next"
      type="button"
      aria-label="Siguiente"
      (click)="scrollNext()"
    >
      <app-icon [icon]="chevronRight" [size]="20" />
    </button>
  </div>

  <div class="game-blog__footer">
    <a [routerLink]="'/blog'" [queryParams]="viewAllQueryParams()" class="game-blog__view-all">
      Ver todos los artículos de {{ gameName() }} &rarr;
    </a>
  </div>
</div>
